import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { api, formatError } from "@/lib/api";

const FIELDS = [
  { k: "kcal", label: "Calorie (kcal)" },
  { k: "protein", label: "Proteine (g)" },
  { k: "carbs", label: "Carboidrati (g)" },
  { k: "fat", label: "Grassi (g)" },
  { k: "water_ml", label: "Acqua (ml)" },
];

export const GoalsDialog = ({ open, onOpenChange, goals, onSaved }) => {
  const [f, setF] = useState({});

  useEffect(() => {
    if (open) setF(goals || {});
  }, [open, goals]);

  const save = async (e) => {
    e.preventDefault();
    try {
      await api.put("/nutri/goals", Object.fromEntries(FIELDS.map(({ k }) => [k, parseInt(f[k], 10) || 0])));
      toast.success("Obiettivi aggiornati");
      onOpenChange(false);
      onSaved();
    } catch (err) {
      toast.error(formatError(err));
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="goals-dialog" data-lenis-prevent className="border-[rgba(152,191,162,0.25)] bg-[#0b120e]">
        <DialogHeader>
          <DialogTitle className="font-display text-3xl font-900 uppercase">I tuoi obiettivi</DialogTitle>
          <DialogDescription className="text-[#a3b1aa]">Obiettivi giornalieri usati nel diario e nel riepilogo.</DialogDescription>
        </DialogHeader>
        <form onSubmit={save} className="grid grid-cols-2 gap-4">
          {FIELDS.map(({ k, label }) => (
            <label key={k} className={`space-y-1.5 ${k === "kcal" ? "col-span-2" : ""}`}>
              <span className="font-mono text-[11px] uppercase tracking-widest text-[#a3b1aa]">{label}</span>
              <Input data-testid={`goal-input-${k}`} type="number" min="0" value={f[k] ?? ""} onChange={(e) => setF((v) => ({ ...v, [k]: e.target.value }))} />
            </label>
          ))}
          <button data-testid="goals-save-btn" className="col-span-2 bg-[#98bfa2] py-3 font-display text-lg font-800 uppercase text-[#050807] hover:bg-[#c4dcca]">Salva obiettivi</button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
